import type { LookupModel } from '../app/types/lookup.type.ts';
import baseApi from './meeting-md-api-slice';

const accountTypeApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchAccountTypes: builder.query<LookupModel[], void>({
      query() {
        return `/accountType`;
      },
    }),
  }),
});

export const { useFetchAccountTypesQuery } = accountTypeApi;
